'use strict';

exports.__esModule = true;
exports.default = connectSubmit;

var _reactRedux = require('react-redux');

var _createContextExtractor = require('./createContextExtractor');

var _createContextExtractor2 = _interopRequireDefault(_createContextExtractor);

var _hasApiErrors = require('./hasApiErrors');

var _hasApiErrors2 = _interopRequireDefault(_hasApiErrors);

var _hasErrors = require('./hasErrors');

var _hasErrors2 = _interopRequireDefault(_hasErrors);

var _hasValues = require('./hasValues');

var _hasValues2 = _interopRequireDefault(_hasValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function connectSubmit(Submit) {
  return (0, _createContextExtractor2.default)('Submit')((0, _reactRedux.connect)(function (state, _ref) {
    var disabled = _ref.disabled,
        onionFormName = _ref.onionFormName,
        onionIsValid = _ref.onionIsValid;

    var anyValidationErrors = (0, _hasErrors2.default)(state, onionFormName);
    var anyApiErrors = (0, _hasApiErrors2.default)(state, onionFormName);
    var anyValues = (0, _hasValues2.default)(state, onionFormName);

    return {
      disabled: anyValidationErrors || !!disabled,
      hasErrors: anyValidationErrors || anyApiErrors,
      valid: onionIsValid(),
      hasValues: anyValues
    };
  }, function (state, _ref2) {
    var _onClick = _ref2.onClick,
        onionOnSubmit = _ref2.onionOnSubmit;
    return {
      onClick: function onClick(event) {
        return onionOnSubmit(event) && typeof _onClick === 'function' && _onClick(event);
      }
    };
  })(Submit));
}
module.exports = exports['default'];